import useSWR from "swr"
import API from "./api"

import { addUserScope } from "../../services/sentry"

function onInitLoad(user) {
  // Based on sentry reports, the irony, data aka user is sometimes returned as undefined
  // docs aren't clear what is classed as success so it might include non 200 error codes
  // if the data is undefined exit early
  if (!user) {
    return
  }
  addUserScope(user)
}

export function checkPermissions(userPermissions, action, controller) {
  const permissions = userPermissions[controller]

  if (permissions === undefined) return false
  const actions = Object.keys(permissions)

  switch (action) {
    case "any":
      return actions.length === 0 || actions.some((el) => permissions[el])
    case "all":
      return actions.length === 0
        ? false
        : actions.every((el) => permissions[el])
    default:
      return permissions[action] || false
  }
}

export default function useCurrentUser() {
  const key = "/users/current"
  const { data: user, error } = useSWR(key, API.get, {
    suspense: true,
    onSuccess: onInitLoad,
  })

  if (error || user === undefined) return undefined

  function can(action, controller) {
    return checkPermissions(user.permissions, action, controller)
  }

  function cannot(action, controller) {
    return !can(action, controller)
  }

  user.can = can
  user.cannot = cannot

  return user
}
